import React, { createContext, useMemo, useState } from "react";
import { SwipeableDrawer, IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/MenuOutlined";

// Lets descendants close the drawer they live in (e.g. after an SPA navigation
// that does not reload the page) and observe whether it is open (e.g. to reset
// transient UI when it closes). Defaults to a no-op close and open:true so
// consumers outside a drawer (the permanent desktop sidebar) stay safe.
export const NavDrawerContext = createContext({ open: true, close: () => {} });

// Hamburger button that opens a full-height drawer holding its children. Used by
// the desktop navbar to collect nav controls (school switcher, OneRoster actions,
// nav menu, etc.). The drawer leaves a small gap on the opposite edge and caps
// its width so it never spans the full viewport. Anchor is configurable.
export default function NavDrawerButton({
  children,
  ariaLabel = "Open menu",
  anchor = "left",
}) {
  const [open, setOpen] = useState(false);
  const contextValue = useMemo(
    () => ({ open, close: () => setOpen(false) }),
    [open]
  );

  return (
    <>
      <IconButton aria-label={ariaLabel} onClick={() => setOpen(true)}>
        <MenuIcon sx={{ color: "#00000080" }} />
      </IconButton>
      <SwipeableDrawer
        anchor={anchor}
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        disableDiscovery
        slotProps={{
          paper: {
            sx: {
              width: "calc(100% - 56px)",
              maxWidth: 320,
              height: "100%",
              borderRadius: 0,
            },
          },
        }}
      >
        <NavDrawerContext.Provider value={contextValue}>
          {children}
        </NavDrawerContext.Provider>
      </SwipeableDrawer>
    </>
  );
}
